import { render, staticRenderFns } from "./treeChild.vue?vue&type=template&id=aeae588c&scoped=true"
import script from "./treeChild.vue?vue&type=script&lang=js"
export * from "./treeChild.vue?vue&type=script&lang=js"
import style0 from "./treeChild.vue?vue&type=style&index=0&id=aeae588c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aeae588c",
  null
  
)

export default component.exports